"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetImageSource = getAssetImageSource;
function getAssetImageSource(asset) {
    return asset.storageKey || undefined;
}
